import styled from "styled-components";

export const FormGroup = styled.div`
    display: flex;
    width: 48%;
    flex-direction: column;
    margin: 10px 0;
    @media (max-width: 768px) {
        width: 100%;
    }
`;
export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: 20px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;
export const Textarea = styled.textarea`
    width: 50%;
    height: 100px;
    border-radius: 5px;
    margin-block: 15px;
`;
export const FormRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    flex: 1;
    /* align-items: baseline; */
    width: 100%;
    margin-bottom: 8px;
`;

export const FormGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 7px;
    justify-content: space-between;
`;

export const FormStyle = styled.form`
    padding-bottom: 4rem;
`;

export const FormGroupTextEditor = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin: 10px 0;
`;
export const FormTitle = styled.div`
    display: flex;
    font-size: 24px;
    font-weight: 700;
    text-transform: capitalize;
    align-items: center;
    margin: 3rem 0;
`;
export const RowFormGroupContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
`;
export const StyledLabel = styled.label`
    font-size: 14px;
    font-weight: 400;
    color: #69707d;
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;
`;
export const StyledSubLabel = styled.label`
    font-size: 12px;
    font-weight: 400;
    color: #98a2b3;
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;
    margin-left: 10px;
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
export const StyledRequired = styled.span`
    color: red;
`;
export const Error = styled.label`
    margin-top: 8px;
    color: #ff0000;
    font-size: 0.8rem;
`;
export const Hint = styled.div`
    display: flex;
`;
export const HintMessageContent = styled.div`
    display: flex;
    flex-direction: column;
    h3 {
        color: #92400e;
        margin-bottom: 6px;
        font-weight: 500;
        font-size: 14px;
        text-transform: capitalize;
    }
    p {
        color: #000;
        font-size: 13px;
        font-weight: 400;
    }
    label {
        font-weight: 700;
        margin-bottom: 0.5rem;
        text-transform: capitalize;
        display: flex;
        color: #92400e;
    }
    .decline-item {
        margin-bottom: 1rem;
    }
`;

export const WarningMessage = styled.p`
    margin-top: 8px;
    color: yellow;
    font-size: 1rem;
`;
